import React, { Component } from 'react';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
  Typography,
  Divider,
} from '@material-ui/core';
import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import page404 from 'assets/img/404.png';
import LoadingOverlay from 'react-loading-overlay';
import ScaleLoader from 'react-spinners/ScaleLoader';
import StorageService from '../../services/api/Storage';
import axios from 'axios';
import Brightness4Icon from '@material-ui/icons/Brightness4';
import '../../assets/css/catalog.css';
import { notebookData } from 'services/axiosCallback';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export default class CodeDiff extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstFileContent: '',
      secondFileContent: '',
      /* for removing prfix from the file name added in parent */
      firstFileName: this.props.selectedFiles[0]?.substring(
        this.props.selectedFiles[0].indexOf('_') + 1
      ),
      secondFileName: this.props.selectedFiles[1]?.substring(
        this.props.selectedFiles[1].indexOf('_') + 1
      ),

      firstFileType: '',
      secondFileType: '',
      storageId: '',
      rootFolder: '',
      loading: false,
      markoptions: [],
      darkMode: false,
    };
  }

  componentDidMount() {
    this.setState({
      firstFileType: 'ipynb',
      secondFileType: 'ipynb',
    });
    if (this.state?.firstFileName.endsWith('ipynb')) {
      this.downloadUrlForFileOne();
    } else if (!this.state?.firstFileName.endsWith('ipynb')) {
      let fileName = this.state?.firstFileName.substring(
        0,
        this.state?.firstFileName.lastIndexOf('/')
      );
      let version = this.state?.firstFileName.substring(
        this.state?.firstFileName.lastIndexOf('/') + 1
      );
      this.downloadVersionUrlForFileOne(fileName, version);
    }

    if (this.state?.secondFileName.endsWith('ipynb')) {
      this.downloadUrlForFileTwo();
    } else if (!this.state?.secondFileName.endsWith('ipynb')) {
      let fileName = this.state?.secondFileName.substring(
        0,
        this.state?.secondFileName.lastIndexOf('/')
      );
      let version = this.state?.secondFileName.substring(
        this.state?.secondFileName.lastIndexOf('/') + 1
      );
      this.downloadVersionUrlForFileTwo(fileName, version);
    }
  }

  downloadUrlForFileOne = () => {
    this.setState({
      loading: true,
    });
    StorageService.downloadObjectUrl(
      this.state.firstFileName,
      this.state.storageId,
      this.state.rootFolder
    )
      .then((response) => {
        this.renderTextForFileOne(response.download_url);
        this.setState({ DownloadUrl: response.download_url });
      })
      .catch((error) => {
        this.state.firstFileType = 'png';
        this.state.firstFileContent = page404;
        this.state.firstFileName = 'File Not Found!!!';
        this.setState({ loading: false });
      });
  };

  downloadVersionUrlForFileOne = (fileName, version) => {
    this.setState({
      loading: true,
    });
    StorageService.downloadVersionFilesUrl(
      fileName,
      version,
      this.state.storageId,
      this.state.rootFolder
    )
      .then((response) => {
        this.renderTextForFileOne(response.download_url);
        this.setState({ DownloadUrl: response.download_url });
      })
      .catch((error) => {
        this.state.firstFileType = 'png';
        this.state.firstFileContent = page404;
        this.state.firstFileName = 'File Not Found!!!';
        this.setState({ loading: false });
      });
  };

  getFinalStringOutPut = (data) => {
    let string = '';
    data.cells.forEach((item) => {
      if (typeof item.source === 'string') {
        string += item.source;
      } else {
        item.source.forEach((innerItem) => {
          string = string + innerItem;
        });
      }
    });

    return string;
  };

  downloadUrlForFileTwo = () => {
    StorageService.downloadObjectUrl(
      this.state.secondFileName,
      this.state.storageId,
      this.state.rootFolder
    )
      .then((response) => {
        this.renderTextForFileTwo(response.download_url);
        this.setState({ DownloadUrl: response.download_url });
      })
      .catch((error) => {
        this.state.secondFileType = 'png';
        this.state.secondFileContent = page404;
        this.state.secondFileName = 'File Not Found!!!';
        this.setState({ loading: false });
      });
  };

  downloadVersionUrlForFileTwo = (fileName, version) => {
    StorageService.downloadVersionFilesUrl(
      fileName,
      version,
      this.state.storageId,
      this.state.rootFolder
    )
      .then((response) => {
        this.renderTextForFileTwo(response.download_url);
        this.setState({ DownloadUrl: response.download_url });
      })
      .catch((error) => {
        this.state.firstFileType = 'png';
        this.state.firstFileContent = page404;
        this.state.firstFileName = 'File Not Found!!!';
        this.setState({ loading: false });
      });
  };

  renderTextForFileOne = (url) => {
    if (
      this.state.firstFileType == 'jpeg' ||
      this.state.firstFileType == 'jpg' ||
      this.state.firstFileType == 'png'
    ) {
      this.setState({
        firstFileContent: url,
        loading: false,
      });
    } else {
      axios.get(url).then((response) => {
        let notebook;
        if (this.state.firstFileType == 'ipynb') {
          notebookData(url, (response) => {
            if (response.status === 'success') {
              notebook = response.data;
              let result = this.getFinalStringOutPut(notebook);
              this.setState({ firstFileContent: result, loading: false });
            }
          });
        } else {
          this.setState({
            firstFileType: 'others',
            firstFileContent: notebook.toString(),
            loading: false,
          });
        }
      });
    }
  };

  renderTextForFileTwo = (url) => {
    this.setState({
      loading: true,
    });
    if (
      this.state.secondFileType == 'jpeg' ||
      this.state.secondFileType == 'jpg' ||
      this.state.secondFileType == 'png'
    ) {
      this.setState({
        secondFileContent: url,
        loading: false,
      });
    } else {
      let notebook;
      if (this.state.secondFileType == 'ipynb') {
        notebookData(url, (response) => {
          if (response.status === 'success') {
            notebook = response.data;
            this.setState(
              {
                loading: false,
              },
              () => {
                let result = this.getFinalStringOutPut(notebook);
                this.setState({ secondFileContent: result });
              }
            );
          }
        });
      } else {
        this.setState({
          secondFileType: 'others',
          secondFileContent: notebook.toString(),
          loading: false,
        });
      }
    }
  };

  render() {
    return (
      <div>
        <Dialog
          maxWidth='lg'
          fullWidth
          open={this.props.openDiaog}
          TransitionComponent={Transition}
        >
          <DialogTitle>
            <Box className='dialog-title-box'>
              <Typography variant='h5'>Compare Files</Typography>
              <Tooltip title='Dark mode' placement='bottom'>
                <Brightness4Icon
                  onClick={() =>
                    this.setState({ darkMode: !this.state.darkMode })
                  }
                  style={{
                    marginLeft: 'auto',
                    marginRight: '20px',
                    color: this.state.darkMode ? '#fff' : null,
                    backgroundColor: this.state.darkMode ? 'black' : 'white',
                  }}
                  className={`brigtness-icon ${
                    this.state.darkMode ? 'white-black' : 'black-white'
                  } `}
                />
              </Tooltip>
              <Tooltip title='Close' placement='bottom'>
                <CloseIcon
                  className='cursor-pointer'
                  onClick={() => this.props.closeDialog()}
                />
              </Tooltip>
            </Box>
          </DialogTitle>
          <Divider />
          <DialogContent>
            <LoadingOverlay
              active={this.state.loading}
              spinner={
                <ScaleLoader
                  height={35}
                  width={5}
                  radius={2}
                  margin={2}
                  color={'#123abc'}
                  loading={this.state.loading}
                />
              }
            >
              <Box className='dialog-title-box'>
                {/* for removing prfix from the file name added in parent */}
                <h6>
                  {this.props.selectedFiles[0]?.substring(
                    this.props.selectedFiles[0]?.indexOf('_') + 1
                  )}
                </h6>
                <h6>
                  {this.props.selectedFiles[1]?.substring(
                    this.props.selectedFiles[1]?.indexOf('_') + 1
                  )}
                </h6>
              </Box>
              <div className='diffviewer-wrapper-div'>
                <ReactDiffViewer
                  oldValue={this.state.firstFileContent}
                  newValue={this.state.secondFileContent}
                  splitView={true}
                  useDarkTheme={this.state.darkMode}
                  compareMethod={DiffMethod.CHARS}
                />
              </div>
            </LoadingOverlay>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}
